const ASCII_FILE_NAME_CHAR_CLASS = 'A-Za-z0-9_-';

/** Matches file names containing only ASCII letters, digits, underscores, and hyphens. */
export const ASCII_FILE_NAME_PATTERN = new RegExp(
  `^[${ASCII_FILE_NAME_CHAR_CLASS}]+$`
);

const NON_ASCII_FILE_NAME_CHAR_PATTERN = new RegExp(
  `[^${ASCII_FILE_NAME_CHAR_CLASS}]`,
  'g'
);

/**
 * Returns whether a file name contains only allowed ASCII characters.
 */
export const isAsciiFileName = (fileName: string): boolean =>
  ASCII_FILE_NAME_PATTERN.test(fileName.trim());

/**
 * Sanitizes a source name into an ASCII-safe file name.
 * Non-allowed characters are replaced with underscores; empty input uses the fallback.
 */
export const toAsciiFileName = (
  sourceName?: string,
  fallback = 'export'
): string => {
  if (!sourceName?.trim()) {
    return fallback;
  }

  const sanitized = sourceName
    .trim()
    .replace(NON_ASCII_FILE_NAME_CHAR_PATTERN, '_');
  return sanitized.length > 0 ? sanitized : fallback;
};
